export default "__VITE_ASSET__CbsCcU$T__"